"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebContractListPurchaseHistoryResponseSchema = exports.WebContractListOrdersResponseSchema = exports.WebContractGetOrderResponseSchema = exports.WebContractListOrdersQueryParamsSchema = exports.WebContractCreateOrderRequestSchema = void 0;
const zod_1 = require("zod");
const shared_1 = require("../../../shared");
const schema_builder_1 = require("../../../shared/schema-builder");
const web_orders_schema_1 = require("./web.orders.schema");
const ShippingMethodSchema = zod_1.z.enum(['STANDARD', 'EXPRESS']);
const ShippingStatusSchema = zod_1.z.enum(['PENDING', 'SHIPPED', 'CANCELLED']);
const OrderTypeSchema = zod_1.z.enum(['GUEST', 'MEMBER']);
const OrderStatusSchema = zod_1.z.enum(['PENDING', 'CONFIRMED', 'SHIPPED', 'CANCELLED']);
const RoleSchema = zod_1.z.enum(['ADMIN', 'STAFF', 'USER']);
const PaymentStatusSchema = zod_1.z.enum(['PENDING', 'PAID', 'FAILED', 'REFUNDED']);
const PaymentMethodSchema = zod_1.z.enum(['QR_CODE', 'PAYPAL']);
const OrderAddressTypeSchema = zod_1.z.enum(['BILLING', 'SHIPPING']);
const ShippingSchema = zod_1.z.object({
    shippingMethod: ShippingMethodSchema,
    status: ShippingStatusSchema,
    id: zod_1.z.string().uuid(),
    orderId: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    shippedAt: zod_1.z.coerce.date().nullable(),
    trackingNumber: zod_1.z.string().nullable(),
    trackingUrl: zod_1.z.string().nullable(),
});
const OrderSchema = zod_1.z.object({
    type: OrderTypeSchema,
    status: OrderStatusSchema,
    id: zod_1.z.string().uuid(),
    userId: zod_1.z.string().nullable(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    expiredAt: zod_1.z.coerce.date(),
    orderNo: zod_1.z.number().int(),
    email: zod_1.z.string(),
    phone: zod_1.z.string(),
    name: zod_1.z.string(),
    discountDetails: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).nullable(),
    memberDiscount: zod_1.z.number(),
    promotionDiscount: zod_1.z.number(),
    shippingFee: zod_1.z.number(),
    finalPrice: zod_1.z.number(),
});
const PaymentSchema = zod_1.z.object({
    status: PaymentStatusSchema,
    method: PaymentMethodSchema,
    id: zod_1.z.string().uuid(),
    orderId: zod_1.z.string(),
    transactionId: zod_1.z.string(),
    paypalOrderId: zod_1.z.string().nullable(),
    paypalCaptureId: zod_1.z.string().nullable(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    paymentAt: zod_1.z.coerce.date().nullable(),
    amount: zod_1.z.number(),
    imageUrl: zod_1.z.string().nullable(),
});
const OrderItemSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    orderId: zod_1.z.string(),
    productId: zod_1.z.string(),
    discountId: zod_1.z.string().nullable(),
    quantity: zod_1.z.number().int(),
    unitPrice: zod_1.z.number(),
    discountPrice: zod_1.z.number().nullable(),
});
const OrderAddressSchema = zod_1.z.object({
    type: OrderAddressTypeSchema,
    id: zod_1.z.string().uuid(),
    recipientName: zod_1.z.string(),
    recipientPhoneNumber: zod_1.z.string(),
    address: zod_1.z.string(),
    address2: zod_1.z.string().nullable(),
    district: zod_1.z.string(),
    province: zod_1.z.string(),
    postalCode: zod_1.z.string(),
    orderId: zod_1.z.string(),
    countryCode: zod_1.z.string(),
});
const ProductSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    collectionId: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    deletedAt: zod_1.z.coerce.date().nullable(),
    restockedAt: zod_1.z.coerce.date().nullable(),
    name: zod_1.z.string(),
    slug: zod_1.z.string(),
    skuNo: zod_1.z.string(),
    coverImage: zod_1.z.string(),
    images: zod_1.z.string().array(),
    description: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).nullable(),
    price: zod_1.z.number(),
    priceUsd: zod_1.z.number(),
    stock: zod_1.z.number().int(),
    isAvailable: zod_1.z.boolean(),
    frameShape: zod_1.z.string().nullable(),
    frameColor: zod_1.z.string().nullable(),
    lensColor: zod_1.z.string().nullable(),
    isPolarized: zod_1.z.boolean(),
});
const ProductReviewSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    userId: zod_1.z.string(),
    productId: zod_1.z.string(),
    orderItemId: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    rating: zod_1.z.number(),
    comment: zod_1.z.string(),
    images: zod_1.z.string().array(),
});
const UserSchema = zod_1.z.object({
    role: RoleSchema,
    id: zod_1.z.string().uuid(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    deletedAt: zod_1.z.coerce.date().nullable(),
    email: zod_1.z.string(),
    name: zod_1.z.string(),
    dateOfBirth: zod_1.z.coerce.date().nullable(),
    phoneNumber: zod_1.z.string(),
});
exports.WebContractCreateOrderRequestSchema = zod_1.z.object({
    name: zod_1.z.string().nonempty(),
    email: zod_1.z.string().email().nonempty(),
    phone: zod_1.z.string().nonempty(),
    type: zod_1.z.literal('MEMBER'),
    billingAddress: web_orders_schema_1.OrderAddressRequestSchema,
    shippingAddress: web_orders_schema_1.OrderAddressRequestSchema,
    shippingMethod: ShippingMethodSchema,
    promotionId: zod_1.z.string().optional().nullable(),
});
exports.WebContractListOrdersQueryParamsSchema = shared_1.ContractPaginationQueryParamsSchema
    .extend({ sortBy: zod_1.z.string().default('createdAt|desc') });
const OrderResponseSchema = new schema_builder_1.SchemaBuilder(OrderSchema)
    .replaceDateField('createdAt')
    .replaceDateField('updatedAt')
    .replaceDateField('expiredAt', zod_1.z.string().datetime().nullable())
    .omit('discountDetails')
    .build();
const OrderItemResponseSchema = new schema_builder_1.SchemaBuilder(OrderItemSchema).build();
const CustomerResponseSchema = new schema_builder_1.SchemaBuilder(UserSchema)
    .replaceDateField('createdAt')
    .replaceDateField('updatedAt')
    .replaceDateField('deletedAt', zod_1.z.string().datetime().nullable())
    .build();
const PaymentResponseSchema = new schema_builder_1.SchemaBuilder(PaymentSchema)
    .replaceDateField('createdAt')
    .replaceDateField('updatedAt')
    .replaceDateField('paymentAt', zod_1.z.string().datetime().nullable())
    .build();
const ShippingResponseSchema = new schema_builder_1.SchemaBuilder(ShippingSchema)
    .replaceDateField('createdAt')
    .replaceDateField('shippedAt', zod_1.z.string().datetime().nullable())
    .build();
const WebContractOrderSchema = OrderResponseSchema
    .extend({
    skuCount: zod_1.z.number().int().positive(),
    itemCount: zod_1.z.number().int().positive(),
    beforeDiscount: zod_1.z.number().nonnegative(),
    afterDiscount: zod_1.z.number().nonnegative(),
    shippingAddress: OrderAddressSchema.extend({ countryName: zod_1.z.string() }).nullable(),
    billingAddress: OrderAddressSchema.extend({ countryName: zod_1.z.string() }).nullable(),
    shipping: ShippingResponseSchema.nullable(),
    payment: PaymentResponseSchema.array().nullable(),
    orderItems: OrderItemResponseSchema.extend({
        product: ProductSchema,
        productReview: ProductReviewSchema.nullable(),
    }).array().nullable(),
    customer: CustomerResponseSchema.nullable(),
});
exports.WebContractGetOrderResponseSchema = zod_1.z.object({ order: WebContractOrderSchema });
exports.WebContractListOrdersResponseSchema = shared_1.ContractBaseListResponseSchema
    .extend({
    orders: OrderResponseSchema.extend({
        payment: PaymentResponseSchema.array().nullable(),
        shipping: ShippingResponseSchema.nullable(),
    }).array(),
});
exports.WebContractListPurchaseHistoryResponseSchema = shared_1.ContractBaseListResponseSchema
    .extend({
    purchases: zod_1.z.object({
        id: zod_1.z.string(),
        purchaseDate: zod_1.z.string().datetime(),
        productImage: zod_1.z.string().url(),
        productName: zod_1.z.string(),
        quantity: zod_1.z.number().int().positive(),
        unitPrice: zod_1.z.number().positive(),
        discountPrice: zod_1.z.number().nonnegative().nullable(),
        impactAmount: zod_1.z.number().nonnegative(),
    }).array(),
});
